module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "portfolio-item project",
    class: 'size-' + _vm.tiles
  }, [_c('router-link', {
    attrs: {
      "to": _vm.link
    }
  }, [_c('div', {
    staticClass: "project-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": _vm.link
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview"
  }, [_c('img', {
    attrs: {
      "src": _vm.preview,
      "alt": _vm.link + ' Preview'
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "blender-1",
    style: ({
      background: _vm.background
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "blender-2",
    style: ({
      background: _vm.background
    })
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fb46d6e"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/partials/project-internal.vue
// module id = 63
// module chunks = 0